
import React, { Fragment } from 'react';
import loginNavenderLogo from './bgwithlogo.svg';
import allCustomers from './all_customers.svg';
import ModalBgCover from '../common/modal-bg-cover';
import LoadingState from '../../components/common/loading-state';
import PropTypes from 'prop-types';
import gaPush from '../../globs/utils/google-analytics';
import config from '../../../src/globs/config'
import NotificationBell from './notification-bell.svg';
import SettingsIcon from './settings-icon.svg';
import ClickitLogo from '../../images/clickit-logo.png';

class HomePage extends React.Component {
    static propTypes = {
        appLogout: PropTypes.func.isRequired,
        appReload: PropTypes.func.isRequired,
    }
    // static defaultProps = {
    //     dataLoad: undefined,
    // }

    state = {
        logOutPop: false,
        showLoader: false,
    }

    componentDidMount() {
        this.fireGaEventPagePath(window.location.pathname +  
            window.location.search);
        const { props } = this;
        const salesOfficerId = props.user.id;
        const url = `${config.apiContextPath}/sales_officers/${salesOfficerId}/dashboards`;
        props.dataLoad({
            key: 'dashboard',
            url: url
        });

    }

    fireGaEventPagePath = (path) => {
        gaPush('pageview', {
          path,
        });
      };

      fireGaEvent = (act, action, label) => {
        gaPush('event', {
          category: act,
          action,
          label,
        });
      };

    customerListPage = () => {
        this.fireGaEvent('Homepage', 'CustomerActivityClicked', `${this.props.customerCount.count}`);
        this.props.history.push('/customer-list')
    }
    settingsPage = () => {
        // this.fireGaEvent('Homepage', 'CustomerActivityClicked', `${this.props.customerCount.count}`);
        this.props.history.push('/settings')
    }
    notificationsPage = () => {
        // this.fireGaEvent('Homepage', 'CustomerActivityClicked', `${this.props.customerCount.count}`);
        this.props.history.push('/notifications')
    }
    logOutPop = () => {
        this.setState({
            logOutPop: true,
        });
    }

    logOut = () => {
        const  user = this.props.user;
        const url = `${config.apiContextPath}/sales_officers/${user.id}/logout`;
        this.fireGaEvent('Logout', 'Logout', `${this.props.user.google_user_id}`);
        this.props.appLogout({url, user});
        // this.setState({
        //     logOutPop: false,
        // });
        // this.props.history.push('/login')
        // window.localStorage.clear();
    }

    closeMenu = () => {
        this.setState({
            logOutPop: false
        })
    }
    // refresh = () =>{
    //     window.location.reload();
        
    // }
    appRefresh = () => {
        this.setState({
            showLoader: true,
        });
        this.props.appReload();
    }
    render() {
        const { props } = this;
        return (
            <div className="home-page">
                <img src={loginNavenderLogo} alt="logo" />
                <div className="lr-right-menu" onClick={this.logOutPop}>
                    <button className="in-app-notification-button" onClick={this.notificationsPage}>
                        <img className="bell-icon" src={NotificationBell} alt="Bell" />
                        {
                            props.user.unread_notifications_count > 0 &&
                            <span className="new-notification-count">
                                {props.user.unread_notifications_count}
                                {props.user.unread_notifications_count > 999 && ' + '}
                            </span>
                        }
                    </button>
                    <button type="button" id="openMenu" className="lr-right-menu__open-button">
                        <i className="icon-setting_menu" />
                    </button>
                </div>
                {
                    this.state.showLoader &&
                    <div>
                        <LoadingState />
                        <div className="loadingContainer" />
                    </div>
                }
                { this.state.logOutPop &&
                <Fragment>
                    <ModalBgCover onTouch={this.closeMenu} />
                    <div className="lr-right-menu__list">
                        <button
                            type="button"
                            className="lr-right-menu__list-item is-reload"
                            onClick={this.appRefresh}
                        >
                            <i className="icon-refresh" />
                            <span>Refresh</span>
                        </button>
                        <button type="button" className="lr-right-menu__list-item is-settings" onClick={this.settingsPage}>
                            <img className="settings-icon" src={SettingsIcon} alt="settings" />
                            <span>Settings</span>
                        </button>
                        <button type="button" className="lr-right-menu__list-item is-logout" onClick={this.logOut} id="logoutbtn">
                            <i className="icon-logout" />
                            <span>Logout</span>
                        </button>
                    </div>
                </Fragment>
                 }
                <div className="welcome">
                    <span>Welcome</span>
                    {/* <button
                        onClick={() =>
                            Event("Home", "render home page ", "HOME_PAGE")
                        } >Add to Cart</button> */}
                    <span>{this.props.user.username}</span>
                </div>
                <div className="customer-activity" onClick={this.customerListPage}>
                    <img src={allCustomers} alt="customer" />
                    <span>Customer Activity</span>
                    <i className="icon-arrow_right" />
                </div>  

                {/* <div className="lr-customer-pop">
                    <div className="clickit-pop"> */}
                        {/* <img src={ClickitLogo} className="na-url-ct-logo" />
                        <p className="na-url-msg">Clickit So has a new home!</p>
                        <p className="na-url-msg">We've moved to a new link : <a href="https://navendor-so.clickitapp.io/" target="_blank">https://navendor-so.clickitapp.io/</a> Please bookmark the new link.</p>
                        <a className="na-url-link" href="https://navendor-so.clickitapp.io/" target="_blank" rel="noreferrer">
                        <button  className="na-url-btn">Go there now!</button>
                        </a> */}
                    {/* </div>
                </div>       */}
            </div>
        )
    }
}

export default HomePage;